import React from 'react'
import './ContactUs.scss';

export default function ContactUs() {
  return (
    <div>
        <section className='subBanner textCenter'>
            <div className='middle_box'>
                <h1 className='m-0'>Contact Us</h1>
            </div>
        </section>
        <section className='sectionPadding welcome_wrap aboutUs_wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 textCenter'>
                        <div className='gallery_box_inner'>
                            <div class="titleBox mt-0">
                                <span>Contact</span>
                                <h2>What can we help you with</h2>
                            </div>
                            <p>Please don’t hesitate to get in touch with any questions or enquiries. We will always aim to reply as quickly as we can however if your enquiry is urgent please call us on <a style={{ color:"#E1C267"}} href="tel:9909909311">9909909311</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='conatctForm'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='contactTitle'>
                        <iframe
                                    width="100%"
                                    height="450px"
                                    title="Locatio of property"
                                    src={`https://maps.google.com/maps?q=${21.2053263},${72.8794182}&output=embed`}
                                ></iframe>
                            {/* <h3>Find us</h3>
                            <p>Shop no 18, 19 GF, Silver Plaza, Silver Chowk, Punagam Near Devi Darshan Society surat, Gujarat 395010 India</p>
                            <div className='defultBtn'>
                                <a href="#">Find us on map</a>
                            </div>
                            <hr /> 
                            <h3>Opening Hours</h3>
                            <div className='timeBox'>
                                <ul>
                                    <li><span>Monday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Tuesday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Wednesday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Thursday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Friday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Saturday</span> 10:00 AM – 9:30 PM</li>
                                    <li><span>Sunday</span> 10:00 AM – 9:30 PM</li>
                                </ul>
                            </div>
                            <hr /> 
                            <h3>Reservations</h3>
                            <p><a href="tel:9909909311">9909909311</a> or Book a table <br />For more information <a href="mailto:hello@gmail.com">hello@gmail.com</a></p> */}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='formTitle_wrap'>
                            <div className='title_title'>
                                <h3>Send us a message</h3>
                                <p>Please use the form below to get in touch.</p>
                                <p>If you need a reply we will get in touch as soon as possible.</p>
                            </div>
                            <form action="mailto:otlocafe@gmail.com" method="post" enctype="text/plain">
                            <div className='form'>
                                <div className='formvalue'>
                                    <input placeholder="Name*" type="text" required/>
                                </div>
                                <div className='formvalue'>
                                    <input placeholder="Email*" type="email" required/>
                                </div>
                                <div className='formvalue'>
                                    <textarea placeholder="Message*"></textarea>
                                </div>
                                <div className='sendBtn'>
                                    <button type="submit">Send</button>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='sectionPadding post_wrap'>
            <div className='container'>
            <div className='row'>
                <div className='col-md-4'>
                <div className='image_box contactus-img1 textCenter overlay responsiveSpace'>
                    <div className='contentWrap'>
                    <span>Menus</span>
                    <h2>Book A <br/>Table</h2>
                    <div className='defultBtn'>
                        <a href="#">Reservation</a>
                    </div>
                    </div>                
                </div>
                </div>
                <div className='col-md-4'>
                <div className='image_box contactus-img2 textCenter responsiveSpace overlay'>
                    <div className='contentWrap'>
                    <span>Hungry?</span>
                    <h2>Start your <br/>experience today</h2>
                    <div className='defultBtn'>
                        <a href="#">Menus</a>
                    </div>
                    </div>                
                </div>
                </div>
                <div className='col-md-4'>
                <div className='image_box contactus-img3 textCenter overlay'>
                    <div className='contentWrap'>
                    <span>Hungry?</span>
                    <h2>Start your <br/>experience today</h2>
                    <div className='defultBtn'>
                        <a href="#">Menus</a>
                    </div>
                    </div>                
                </div>
                </div>
            </div>
            </div>        
        </section>
    </div>
  )
}
